import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { FlowStorage } from '@pe/checkout/storage';

@Injectable({
  providedIn: 'root',
})
export class IsStartedIdentification {
  private readonly flowStorage = inject(FlowStorage);
  private readonly router = inject(Router);

  canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot): boolean {
    const flowId = activatedRouteSnapshot.params.flowId;
    const processed = activatedRouteSnapshot.queryParamMap.has('processed');
    const startedIdentification = coerceBooleanProperty(
      this.flowStorage.getData(flowId, 'isIdentificationStarted', false)
    );

    if (startedIdentification && !processed) {
        this.router.navigate(['/pay', 'static-finish', 'fail'], {
          queryParams: {
            message: $localize `:@@checkout_sdk.error.session_expired:Session expired`,
          },
        });

      return false;
    }

    this.flowStorage.clearData(flowId, 'isIdentificationStarted');

    return true;
  }
}
